import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoriesResourceService {
  resources:any;
  baseUrl = environment.baseUrl;
  routeParams:any;

  constructor(private _httpClient : HttpClient) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params.id
        return new Promise((resolve, reject) => {
            Promise.all([
              this.getCategoriesResources()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCategoriesResources(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.baseUrl + 'resource-center?category_id='+this.routeParams)
                .subscribe((response: any) => {
                    this.resources = response.data
                    resolve(response);
                }, reject);
        });
    }
}
